import React from 'react';
import { Shield, Lock, Eye, Database, UserCheck, Bell } from 'lucide-react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const sections = [
    {
      icon: <Database size={28} />,
      title: 'معلومات کا جمع کرنا',
      content: `عمل ایپ استعمال کرتے وقت ہم درج ذیل معلومات جمع کر سکتے ہیں:

• آپ کا نام اور ای میل ایڈریس (رجسٹریشن کے وقت)
• آپ کی عبادت کی پیش رفت اور ترجیحات
• آپ کے آلے کی معلومات جیسے آپریٹنگ سسٹم
• آپ کے مقام کی معلومات (صرف نماز کے اوقات کے لیے)

یہ معلومات صرف ایپ کی فعالیت کو بہتر بنانے کے لیے استعمال ہوتی ہیں۔`
    },
    {
      icon: <Eye size={28} />,
      title: 'معلومات کا استعمال',
      content: `آپ کی معلومات کا استعمال درج ذیل مقاصد کے لیے کیا جاتا ہے:

• آپ کو ذاتی نوعیت کی خدمات فراہم کرنا
• نماز کے درست اوقات دکھانا
• آپ کی عبادت کی پیش رفت کو محفوظ رکھنا
• ایپ کی کارکردگی کو بہتر بنانا
• تکنیکی مسائل کا حل کرنا

ہم آپ کی معلومات کو کسی تیسرے فریق کو نہیں بیچتے۔`
    },
    {
      icon: <Lock size={28} />,
      title: 'ڈیٹا کی حفاظت',
      content: `ہم آپ کی معلومات کی حفاظت کے لیے مندرجہ ذیل اقدامات کرتے ہیں:

• تمام ڈیٹا کی اینکرپشن
• محفوظ سرورز کا استعمال
• باقاعدہ سیکیورٹی آڈٹ
• رسائی کے سخت کنٹرول
• ڈیٹا بیک اپ سسٹم

آپ کی پرائیویسی ہماری اولین ترجیح ہے۔`
    },
    {
      icon: <UserCheck size={28} />,
      title: 'صارف کے حقوق',
      content: `عمل ایپ کے صارف کے طور پر آپ کے درج ذیل حقوق ہیں:

• اپنی معلومات تک رسائی کا حق
• اپنی معلومات میں ترمیم کا حق
• اپنا اکاؤنٹ حذف کرنے کا حق
• ڈیٹا پورٹیبلٹی کا حق
• اعتراض کرنے کا حق

ان حقوق کے استعمال کے لیے ہم سے رابطہ کریں۔`
    },
    {
      icon: <Bell size={28} />,
      title: 'اطلاعات اور کوکیز',
      content: `عمل ایپ میں درج ذیل اطلاعات شامل ہو سکتی ہیں:

• نماز کے اوقات کی یاد دہانی
• روزانہ عبادت کی یاد دہانی
• نئی خصوصیات کی اطلاعات
• اہم اپ ڈیٹس کی اطلاعات

آپ اپنی مرضی سے ان اطلاعات کو آن یا آف کر سکتے ہیں۔`
    },
    {
      icon: <Shield size={28} />,
      title: 'بچوں کی پرائیویسی',
      content: `عمل ایپ ہر عمر کے لیے موزوں ہے:

• 13 سال سے کم عمر بچوں کے لیے والدین کی رضامندی ضروری ہے
• بچوں کی معلومات کو اضافی تحفظ فراہم کیا جاتا ہے
• بچوں کے لیے کوئی نامناسب مواد نہیں ہے
• والدین کنٹرول کی سہولت دستیاب ہے

ہم بچوں کی حفاظت کو سنجیدگی سے لیتے ہیں۔`
    }
  ];

  return (
    <div className="privacy-page">
      {/* Hero Section */}
      <div className="page-hero">
        <div className="container">
          <div className="hero-icon">
            <Shield size={48} />
          </div>
          <h1>پرائیویسی پالیسی</h1>
          <p>عمل ایپ میں آپ کی معلومات کی حفاظت ہماری ترجیح ہے</p>
          <div className="last-updated">
            آخری تازہ کاری: دسمبر 2024
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="page-content">
        <div className="container">
          <div className="intro-text">
            <p>
              عمل ایپ ("ہم"، "ہمارا"، یا "ایپ") آپ کی پرائیویسی کا احترام کرتی ہے۔ یہ پرائیویسی پالیسی بتاتی ہے کہ ہم آپ کی معلومات کیسے جمع، استعمال اور محفوظ کرتے ہیں۔ عمل ایپ استعمال کرنے سے آپ اس پالیسی سے اتفاق کرتے ہیں۔
            </p>
          </div>

          <div className="policy-sections">
            {sections.map((section, index) => (
              <div className="policy-section" key={index}>
                <div className="section-header">
                  <div className="section-icon">
                    {section.icon}
                  </div>
                  <h2>{section.title}</h2>
                </div>
                <div className="section-content">
                  {section.content.split('\n').map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="contact-box">
            <h3>سوالات؟</h3>
            <p>اگر آپ کے پرائیویسی پالیسی کے بارے میں کوئی سوالات ہیں تو براہ کرم ہم سے رابطہ کریں۔</p>
            <a href="mailto:info@amalapp.xyz" className="contact-email">
              info@amalapp.xyz
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
